import { workWithUs } from './items/work-with-us';
// import { joinTheTeam } from './items/join-the-team';
import { sayHi } from './items/say-hi';

export const formsList = [workWithUs, sayHi];
